module.exports = __webpack_public_path__ + "static/media/documentation.82688fd8.svg";